import React,{Component} from 'react'
import PropTypes from 'prop-types'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import TableRow from '@material-ui/core/TableRow'
import TableSortLabel from '@material-ui/core/TableSortLabel'
import Paper from '@material-ui/core/Paper'
import OutlinedInput from '@material-ui/core/OutlinedInput'
import FormControl from '@material-ui/core/FormControl'
import InputAdornment from '@material-ui/core/InputAdornment'
import Button from '@material-ui/core/Button'
import "../assets/explore.css"
import { withNamespaces } from 'react-i18next'
import { Pagination } from '@material-ui/lab'
import httpRequest from '../components/request-api'
import i18n from '../i18n'

function createData(no, memberID, name, gender, handicap ,avatar) {
  return { no, memberID, name, gender, handicap, avatar}
}

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

function downloadCertificate(ev, memberCode) {
  ev.stopPropagation()

  window.open(`https://memberadmin.tga.or.th/api/member/${memberCode}/certificate`, '_self')
}

const headCells = [
  { id: 'no', numeric: "left", disablePadding: true, label: 'No.', sort: true },
  { id: '', numeric: "center", disablePadding: false, label: '', sort: true },
  { id: 'memberID', numeric: "center", disablePadding: false, label: 'Member ID.', sort: false  },
  { id: 'name', numeric: "left", disablePadding: false, label: 'Name', sort: false  },
  { id: 'gender', numeric: "center", disablePadding: false, label: 'Gender', sort: false  },
  { id: 'handicap', numeric: "center", disablePadding: false, label: 'Handicap index', sort: true  },
  { id: 'certificate', numeric: "center", disablePadding: false, label: 'Certificate'  },
];

function EnhancedTableHead(props) {
  const { order, orderBy, onRequestSort } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property)
  }
  const { t } = props

  return (
      <TableRow>
        <TableCell>
        </TableCell>
        {headCells.map((headCell) => (
          <TableCell style={headCell.id === "no" ?{paddingLeft: "5px", textAlign: "center"} : {paddingLeft: "40px"}}
            key={headCell.id}
            align={headCell.numeric}
            padding={headCell.disablePadding ? 'none' : 'default'}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            {headCell.id === "no" || headCell.id === ""? t(headCell.id) :
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              {t(headCell.id)}
              {orderBy === headCell.id ? (
                <span></span>
              ) : null}
            </TableSortLabel>
            }
          </TableCell>
        ))}
        <TableCell>
        </TableCell>
      </TableRow>
  );
}

EnhancedTableHead.propTypes = {
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

function ExploreSet(props) {
  
  const [order, setOrder] = React.useState('asc');
  const [orderBy, setOrderBy] = React.useState('calories');
  const [page] = React.useState(0);
  const [dense] = React.useState(false);
  const [rowsPerPage] = React.useState(25);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleClick = (id) => {
    props.history.push(`${props.isEmbed ? '/embed' : ''}/explore/${id}/${localStorage.getItem("i18nextLng")}`)
  };

  const emptyRows = rowsPerPage - Math.min(rowsPerPage, props.rows.length - page * rowsPerPage);
  const { t } = props;

  const handleSearch = (e) => {
    let { value } = e.target
    props.handleSearchContact(value)
  };

  const Search = (e) => {
    let { value } = e.target
    props.searchMember(value)
  }

  const handleChangePage = (event, page) => {
    props.fetchMemberList(page,localStorage.getItem("i18nextLng"),"") 
  };

  return (
    <main>
    <div className="container" style={{"marginBottom": "7rem"}}>
        <div>
          <div className="row">
          <h3 className="text-left color-text-header col" style={{alignSelf: "center"}}>{t('handicapIndex')}</h3>
          <FormControl fullWidth variant="outlined" className="search col">
            <div className="row j-center">
            <OutlinedInput className="col-xl-8 col-lg-6"
              id="outlined-adornment-amount"
              placeholder={t('search')}
              onChange={e => handleSearch(e)}
              startAdornment={<InputAdornment position="start">  <i className="ti-search" /></InputAdornment>}
            />
            <Button variant="contained" color="primary" className="col-xl-2 col-lg-4" onClick={e => Search(e)}>
            {t('enter')}
            </Button>
          </div>
          </FormControl>
        </div>
         { stableSort(props.rows, getComparator(order, orderBy)).slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).length === 0 && !props.preload ? <h6 className="p-5 text-center" >List not found. Please try again !</h6> :
        <Paper>
            <TableContainer>
              <Table
                  aria-labelledby="tableTitle"
                  size='medium'
                  aria-label="enhanced table"
              >
                  <EnhancedTableHead
                    t={t}
                    order={order}
                    orderBy={orderBy}
                    onRequestSort={handleRequestSort}
                    rowCount={props.rows.length}
                  />
                  <>
                  { props.preload ?
                    <div id="preloader-active">
                      <div class="preloader d-flex align-items-center justify-content-center" style={{backgroundColor: "initial"}}>
                        <div class="preloader-inner position-relative">
                          <div class="preloader-circle"></div>
                          <div class="preloader-img pere-text">
                            <img src="/assets/img/logo/TGALogo.png" alt=""/>
                          </div>
                        </div>
                      </div>
                    </div> :
                  <TableBody>
                  {stableSort(props.rows, getComparator(order, orderBy))
                      .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                      .map((row, index) => {
                        return (
                          <TableRow
                            className="cursor"
                            hover
                            tabIndex={-1}
                            key={row.memberID}
                            onClick={() => handleClick(row.memberID)}
                          >
                            <TableCell>
                            </TableCell>
                            <TableCell component="th" align="center" scope="row" padding="none">
                                {(index+1)+(25*props.page-25)}
                            </TableCell>
                            <TableCell align="center"><div class="image-cropper" style={{width: "50px", height: "50px"}}><img src={ row.avatar ? `data:image/png;base64,${row.avatar}`: `/assets/img/user.png`} alt="" className=" profile-pic"/></div></TableCell>
                            <TableCell align="center" style={{color: "#454243"}}> {row.memberID}</TableCell>
                            <TableCell align="left" style={{color: "#454243", paddingLeft: "40px"}}>{row.name}</TableCell>
                            <TableCell align="center" style={{color: "#454243"}}>{t(row.gender)}</TableCell>
                            <TableCell align="center" style={{color: "#5485D2", fontSize: "1rem"}}>{row.handicap}</TableCell>
                            <TableCell align="center">
                              <Button
                                classes={{ root: 'btn-certificate', label: 'btn-certificate-label' }}
                                elevation={0}
                                variant="contained"
                                fullWidth
                                onClick={(ev) => downloadCertificate(ev, row.memberID)}
                              >
                                {t('download')}
                              </Button>
                            </TableCell>
                            <TableCell>
                            </TableCell>
                          </TableRow>
                      );
                      })}
                    {emptyRows > 0 && (
                        <TableRow style={{ height: (dense ? 33 : 53) * emptyRows }}>
                        <TableCell colSpan={6} />
                        </TableRow>
                    )}
                  </TableBody>
              }
              </>
              </Table>
            </TableContainer> 
           <Pagination count={props.count} page={props.page} size="large" onChange={handleChangePage} className="justify-content-center"/>
        </Paper>
        }
        </div>
    </div>
    </main>
  );
}

class Explore extends Component {
  constructor(props) {
    super(props);
    this.state = {
        golfCourseData: [],
        page: 1,
        count: 0,
        rows : [],
        searchKey:"",
        preload: false,
        isEmbed: props.isEmbed ? props.isEmbed : false
    }
    this.changeLanguage(this.props.match.params.lang)
  }

  changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  }

  handleSearchContact = (e) => {
      this.setState({
        searchKey: e,
      })
  };

  searchMember = () => {
    const { searchKey } = this.state
    this.fetchMemberList(1,localStorage.getItem("i18nextLng"), searchKey)
  };

  componentWillReceiveProps(nextProps) {
    const { page, searchKey } = this.state
    this.fetchMemberList(page,nextProps.lng,searchKey) 
  }

  componentDidMount() {
    this.fetchMemberList(1, localStorage.getItem("i18nextLng"),"")
  }

  setFirstName = (item) => {
    const lng = this.props.lng

    if(lng === 'th'){
    return `${item['th_firstname'] ? item['th_firstname']: item['en_firstname'] } ${item['th_lastname'] ? item['th_lastname'] : item['en_lastname']  }`
    }
    else if(lng === 'en' || lng === 'en-US'){
      return `${item['en_firstname'] ? item['en_firstname'] : item['th_firstname']} ${item['en_lastname'] ? item['en_lastname'] : item['th_lastname'] }`
    } else {
      // Fallback
      return `${item['en_firstname'] ? item['en_firstname'] : item['th_firstname']} ${item['en_lastname'] ? item['en_lastname'] : item['th_lastname'] }`
    }
  }

  fetchMemberList = async (page, language, search) => {
    this.setState({
      preload: true
    })
    let rows = []
    await httpRequest.fetchMemberList(page, language, search).then(result => {
      result.data.result.data.forEach(item => {
        const gender = item.gender === 'm' ? 'men':'women'
        let hcp = item['hcp']
        hcp = hcp !== null ? hcp < 0 ? `+${Math.abs(hcp)}` : hcp.toString() : 'N/A'

        rows.push(createData(item.id, item.code, this.setFirstName(item), gender, hcp, item.avatar))
      })
      this.setState({
          MemberListData: result.data.result.data,
          count: result.data.result.totalPage,
          page : page,
          rows : rows,
          length: result.data.result.data.length,
          preload: false
      })
    }).catch(error => {
        console.log(error);
        this.setState({
          preload: false
        })
    })
}

  render(){
    const { t, history } = this.props;
    const { rows, page, count, length, preload, isEmbed } = this.state
    return(
      <div>
        <ExploreSet isEmbed={isEmbed} preload={preload} page={page} count={count} t={t} history={history} length={length}  rows={rows} handleSearchContact={this.handleSearchContact.bind(this)} fetchMemberList={this.fetchMemberList.bind(this)} searchMember={this.searchMember.bind(this)} />
      </div>
    )
  }
}

export default withNamespaces()(Explore);
